@let company = this.company();

@for (badge of company.badges; track badge) {
    <div [class]="badgeMap.get(badge)?.label">
        <warema-svg-icon filePath="shared-assets/icons/company-address-badge.svg" height="24" width="18" />
        {{ badgeMap.get(badge)?.translationKey ?? '' | translate }}
    </div>
}
